





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Card } from '@/models/Card';

@Component({})
export default class PlayingCard extends Vue {
  @Prop({ default: false }) showFrontFace!: boolean;
  @Prop() card!: Card | null;
  @Prop({ default: false }) clickable!: boolean;

  clickCard() {
    if (this.clickable) this.$emit('click');
  }
}
